module.exports = __webpack_public_path__ + "static/media/client17.5111eaac.webp";